import { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../../Utils/toastContext";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import { debounce } from "lodash";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setStepStatus,
  setRejectedFields,
} from "../../../Redux/store/onboardingFormSlice";
import StatusButton from "../../../Components/onboarding/status-button";
import { clearFileIdsRedux } from "../../../Redux/store/userSlice";
import ReviewPopup from "../../../Components/onboarding/review-popup";
import { useSingleRoutingNumber } from "../../../Components/bank-validations/single-validation";

const LinkAccount = ({ setCurrentStep, applicationType }) => {
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus,
  );
  const individualAccountType = useSelector(
    (state) => state.form.individualAccountType,
  );
  const userStatus = useSelector((state) => state.user.userStatus);
  const routingNumber = useSingleRoutingNumber();
  const routingNumberEdit = useSingleRoutingNumber();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const [showSavedAccount, setShowSavedAccount] = useState(true);
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountHolderNameEdit, setAccountHolderNameEdit] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
  const [swiftCodeEdit, setSwiftCodeEdit] = useState("");
  const [accountNumberEdit, setAccountNumberEdit] = useState("");
  const userId = useSelector((state) => state.user.userId);
  const [branchAddress, setBranchAddress] = useState("");
  const [branchAddressUpdate, setBranchAddressUpdate] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine3, setAddressLine3] = useState("");
  const [addressLine1Edit, setAddressLine1Edit] = useState("");
  const [addressLine2Edit, setAddressLine2Edit] = useState("");
  const [addressLine3Edit, setAddressLine3Edit] = useState("");
  const [bsb, setBsb] = useState("");
  const [bsbEdit, setBsbEdit] = useState("");
  const [isDefault, setIsDefault] = useState("yes");
  const [accountNumber, setAccountNumber] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [paymentMethodData, setPaymentMethodData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [transitNumber, setTransitNumber] = useState("");
  const [swiftError, setSwiftError] = useState("");
  const [transitError, setTransitError] = useState("");
  const navigate = useNavigate();
  const rejectedFields = useSelector((state) => state.form.rejectedFields);

  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedcashCurrencyEdit, setpreselectedcashCurrencyEdit] =
    useState({});
  const [preselectedDefaultAccount, setpreselectedDefaultAccount] = useState(
    {},
  );
  const [preselectedPaymentMethod, setPreselectedPaymentMethod] = useState({
    value: 1,
    label: "ACH",
  });
  const [preselectedBranchIdentifier, setpreselectedBranchIdentifier] =
    useState({
      value: 1,
      label: "Australian",
    });
  const [preselectedBranchIdentifierEdit, setpreselectedBranchIdentifierEdit] =
    useState({});
  const [institutionNumber, setinstitutionNumber] = useState("");
  const [institutionNumberEdit, setinstitutionNumberEdit] = useState("");
  const [transitNumberEdit, setTransitNumberEdit] = useState("");

  const [toCurrency, setToCurrency] = useState(2);
  const [toCurrencyEdit, setToCurrencyEdit] = useState(2);
  const [defaultAccountId, setDefaultAccountId] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [branchIdentifier, setBranchIdentifier] = useState(1);
  const [branchIdentifierEdit, setBranchIdentifierEdit] = useState(1);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: "AU",
    label: "Australia",
  });
  const [preselectedCountryCodeEdit, setpreselectedCountryCodeEdit] = useState(
    {},
  );
  const [countryCode, setCountryCode] = useState("AU");
  const [countryCodeEdit, setCountryCodeEdit] = useState("AU");
  const [bankName, setBankName] = useState("");
  const [bankNameEdit, setBankNameEdit] = useState("");
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [currentBank, setCurrentBank] = useState(null);
  const [currentBankToDefault, setCurrentBankToDefault] = useState(null);
  const [isConfirmDefault, setIsConfirmDefault] = useState(false);
  const [currentBankToActive, setCurrentBankToActive] = useState(null);
  const [isConfirmActive, setIsConfirmActive] = useState(false);
  const [currentBankToEdit, setCurrentBankToEdit] = useState(null);
  const [BranchIdentifierData, setBranchIdentifierData] = useState([]);
  const [fileAttorneyPath, setfileAttorneyPath] = useState("");
  const [fileAvailable, setFileAvailable] = useState(false);
  const [fileAvailableEdit, setFileAvailableEdit] = useState(false);
  const [fileAttorneyPathEdit, setfileAttorneyPathEdit] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [bankdata, setBankdata] = useState([]);
  const [fileBank, setFileBank] = useState(null);
  const [fileBankEdit, setFileBankEdit] = useState(null);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [bsbError, setBsbError] = useState("");
  const fieldLabelMap = {
    account_name: "Account Holder Name",
    account_number: "Account Number",
    iban: "IBAN",
    swift_code: "Swift Code",
    branch_identifier: "Branch Identifier",
    account_bsb: "BSB",
    country_code: "Country",
    institution_number: "Financial Institution Identifier",
    transit_number: "Transit Number",
    routing_number: "Routing Number",
    currency: "Currency",
    proof_image: "Uploaded Docs",
    address_line1: "Address",
    address_line2: "Address",
    address_line3: "Address",
  };
  const isIndividual = applicationType === 1 && individualAccountType == 5;
  const stepIndex = isIndividual ? 3 : 2;

  const currentStatus = stepStatus?.[stepIndex]?.status ?? null;

  const LOCKED_STATUSES = ["IN_REVIEW", "COMPLETED", "APPROVED"];

  const isLocked = LOCKED_STATUSES.includes(currentStatus);
  const isEditable = Boolean(currentStatus) && !isLocked;

  const isInReview = ["IN_REVIEW", "COMPLETED"].includes(currentStatus);
  const isApproved = currentStatus === "APPROVED";
  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode(selectedOption.value);
  };
  const handleSelectCountryCodeEdit = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCodeEdit(selectedOption.value);
  };
  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
  };
  const handleSelectToCurrencyEdit = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrencyEdit(selectedOption.value);
  };
  const handleSelectDefaultAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setDefaultAccountId(selectedOption.value);
  };
  const handleSelectPaymentMethod = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setPaymentMethod(selectedOption.value);
  };
  const handleSelectBranchIdentifier = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setBranchIdentifier(selectedOption.value);
    if (selectedOption.value == 3) {
      setCountryCode("US");
    }
    if (selectedOption.value == 1) {
      setCountryCode("AU");
    }
  };
  const handleBsbChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setBsb(numericValue);

    // Validation: must be 6 digits
    if (numericValue.length === 0) {
      setBsbError("BSB is required");
    } else if (numericValue.length !== 6) {
      setBsbError("BSB must be 6 digits");
    } else {
      setBsbError("");
    }
  };
  const handleBsbChangeEdit = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setBsbEdit(numericValue);

    // Validation: must be 6 digits
    if (numericValue.length === 0) {
      setBsbError("BSB is required");
    } else if (numericValue.length !== 6) {
      setBsbError("BSB must be 6 digits");
    } else {
      setBsbError("");
    }
  };
  const handleTransitChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setTransitNumber(numericValue);

    // Validation: must be 5 digits
    if (numericValue.length === 0) {
      setTransitError("Transit number is required");
    } else if (numericValue.length !== 5) {
      setTransitError("Transit number must be 5 digits");
    } else {
      setTransitError("");
    }
  };
  const handleTransitChangeEdit = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setTransitNumberEdit(numericValue);

    // Validation: must be 5 digits
    if (numericValue.length === 0) {
      setTransitError("Transit number is required");
    } else if (numericValue.length !== 5) {
      setTransitError("Transit number must be 5 digits");
    } else {
      setTransitError("");
    }
  };
  const handleSelectBranchIdentifierEdit = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setBranchIdentifierEdit(selectedOption.value);
    if (selectedOption.value == 3) {
      setCountryCodeEdit("US");
    }
    if (selectedOption.value == 1) {
      setCountryCodeEdit("AU");
    }
  };
  const handleDeleteFile = () => {
    setFileBank(null);
    setFileAvailable(false);
    setfileAttorneyPath("");
  };
  const handleDeleteFileEdit = () => {
    setFileBankEdit(null);
    setFileAvailableEdit(false);
    setfileAttorneyPathEdit("");
  };
  const handleDelete = (bank) => {
    setCurrentBank(bank);
    setIsConfirmDelete(true);
  };

  const handleDefault = (bank) => {
    setCurrentBankToDefault(bank);
    setIsConfirmDefault(true);
  };
  const handleActive = (bank) => {
    setCurrentBankToActive(bank);
    setIsConfirmActive(true);
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handleUploadFileAttorney = useCallback(
    debounce(async (fileUploaded) => {
      let toastMessage = null;
      try {
        const response = await fileUploadNew(fileUploaded);
        if (response.status == 201) {
          setfileAttorneyPath(response.data);
          setFileAvailable(true);
        } else {
          setFileAvailable(false);
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setFileAvailable(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [fileBank], // Dependencies
  );
  const handleUploadFileAttorneyEdit = useCallback(
    debounce(async (fileUploaded) => {
      let toastMessage = null;
      try {
        const response = await fileUploadNew(fileUploaded);
        if (response.status == 201) {
          setfileAttorneyPathEdit(response.data);
          setFileAvailableEdit(true);
        } else {
          setFileAvailableEdit(false);
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setFileAvailableEdit(false);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [fileBank], // Dependencies
  );
  const handleFileChangeBank = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileBank(selectedFile);
        setLoading(true);
        handleUploadFileAttorney(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleFileChangeBankEdit = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileBankEdit(selectedFile);
        setLoading(true);
        handleUploadFileAttorneyEdit(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };

  const handleContinue = () => {
    if (bankdata.length == 0) {
      showToast("Please add atleast one bank.", "error");
      return;
    }
    handlesave();
  };
  const handleSetDefault = (e) => {
    setIsDefault(e.target.value);
  };
  const validateSwift = (value) => {
    const swiftRegex =
      /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    return swiftRegex.test(value);
  };
  const handleSwiftChange = (e) => {
    const value = e.target.value.toUpperCase(); // optional: auto uppercase
    setSwiftCode(value);

    if (value && !validateSwift(value)) {
      setSwiftError("Invalid SWIFT/BIC format");
    } else {
      setSwiftError("");
    }
  };
  const handleSwiftChangeEdit = (e) => {
    const value = e.target.value.toUpperCase(); // optional: auto uppercase
    setSwiftCodeEdit(value);

    if (value && !validateSwift(value)) {
      setSwiftError("Invalid SWIFT/BIC format");
    } else {
      setSwiftError("");
    }
  };
  const handleBack = () => {
    if (applicationType == 1 && individualAccountType == 5) {
      setCurrentStep(3);
    } else {
      setCurrentStep(2);
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getAllEnum = async () => {
    try {
      const response = await GetAPIcalls(
        applicationType == 1
          ? `/v1/onboarding/external-bank/enums`
          : applicationType == 2
            ? `/v1/onboarding/corporate/external-bank/enums`
            : `/v1/onboarding/trust/external-bank/enums`,
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.branch_identifiers.forEach((item) => {
          AllAccount.push({
            value: item.value,
            label: item.name,
          });
        });
        setBranchIdentifierData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const resetApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl =
      applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/reset`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/external-bank/reset`
          : `${BASE_URL}/v1/onboarding/trust/external-bank/reset`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: "success",
        };
        getDetails();
        const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCountryCode = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/country-codes`);

      if (response.status == 200) {
        let AllAccount = [];
        Object.entries(response.data).forEach(([key, value]) => {
          AllAccount.push({
            value: key,
            label: value,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryCodeData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const addAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await submitApplicationAPI();
        if (response.status == 200) {
          // if (applicationType == 1) {
          //   setCurrentStep(5);
          // }
          // if (applicationType == 2) {
          //   setCurrentStep(4);
          // }
          getDetails();
          if (bankdata.length == 0) {
            const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
            if (responseStatus.status == 200) {
              if (responseStatus.data.length > 0) {
                dispatch(setStepStatus(responseStatus.data));
              }
            }
          }
          setAccountHolderName("");
          setBankName("");
          setSwiftCode("");
          setAddressLine1("");
          setAddressLine2("");
          setAddressLine3("");
          setpreselectedBranchIdentifier({});
          setBranchIdentifier(null);
          setBsb("");
          setpreselectedCountryCode({
            value: "AU",
            label: "Australia",
          });
          setCountryCode("AU");
          setTransitNumber("");
          setinstitutionNumber("");
          routingNumber.setFromAPI("");
          setAccountNumber("");
          setpreselectedCurrency({
            value: 2,
            label: "AUD",
          });
          setpreselectedBranchIdentifier({
            value: 1,
            label: "Australian",
          });
          setBranchIdentifier(1);
          setToCurrency(2);
          setIsDefault("yes");
          setFileBank(null);
          setfileAttorneyPath(null);
          setFileAvailable(false);
          toastMessage = {
            message: response.message,
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      bankName,
      accountNumber,
      bsb,
      accountHolderName,
      swiftCode,
      toCurrency,
      routingNumber,
      accountNumber,
      fileAttorneyPath,
      countryCode,
      institutionNumber,
      transitNumber,
    ], // Dependencies
  );
  const submitApplicationAPIFinal = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == "onboarding" ? true : false;

    let apiUrl = isOnbaording
      ? applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/submit-section`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/external-bank/submit-section`
          : `${BASE_URL}/v1/onboarding/trust/external-bank/submit-section`
      : applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/finalize`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/finalize`
          : `${BASE_URL}/v1/onboarding/external-bank/re-submit/finalize`;

    let bodyData = {};
    if (!isOnbaording) {
      bodyData = { user_id: userId };
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleFinalSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPIFinal();
      if (response.status == 200) {
        if (applicationType == 1 && individualAccountType == 5) {
          setCurrentStep(5);
        } else {
          setCurrentStep(4);
        }
        toastMessage = {
          message: response.message,
          type: "success",
        };
        const responseStatus = await GetAPIcalls(`/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const updateAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await submitApplicationAPIUpdate();
        if (response.status == 200) {
          // if (applicationType == 1) {
          //   setCurrentStep(5);
          // }
          // if (applicationType == 2) {
          //   setCurrentStep(4);
          // }
          getDetails();
          setIsOpen(false);
          toastMessage = {
            message: response.message,
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      bankNameEdit,
      accountNumberEdit,
      bsbEdit,
      accountHolderNameEdit,
      swiftCodeEdit,
      toCurrencyEdit,
      routingNumberEdit,
      accountHolderNameEdit,
      fileAttorneyPathEdit,
      countryCodeEdit,
      institutionNumberEdit,
      transitNumberEdit,
    ], // Dependencies
  );
  const deleteAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl =
      applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/${currentBank.id.value}`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/external-bank/${currentBank.id.value}`
          : `${BASE_URL}/v1/onboarding/trust/external-bank/${currentBank.id.value}`;

    let bodyData = {};

    try {
      const response = await fetch(apiUrl, {
        method: "DELETE",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const deleteAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await deleteAPI();
        if (response.status == 200) {
          // if (applicationType == 1) {
          //   setCurrentStep(5);
          // }
          // if (applicationType == 2) {
          //   setCurrentStep(4);
          // }
          setIsConfirmDelete(false);
          getDetails();
          toastMessage = {
            message: response.message,
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [currentBank], // Dependencies
  );
  const makeItDefaultAccountAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == "onboarding" ? true : false;

    let apiUrl = isOnbaording
      ? applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/${currentBankToDefault.id.value}`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/external-bank/${currentBankToDefault.id.value}`
          : `${BASE_URL}/v1/onboarding/trust/external-bank/${currentBankToDefault.id.value}`
      : applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToDefault.id.value}`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToDefault.id.value}`
          : `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToDefault.id.value}`;

    let bodyData = {
      is_default: true,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const makeItDefaultAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await makeItDefaultAccountAPI();
        if (response.status == 200) {
          // if (applicationType == 1) {
          //   setCurrentStep(5);
          // }
          // if (applicationType == 2) {
          //   setCurrentStep(4);
          // }
          setIsConfirmDefault(false);
          getDetails();
          toastMessage = {
            message: response.message,
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [currentBankToDefault], // Dependencies
  );
  const makeItActiveAccountAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == "onboarding" ? true : false;
    let apiUrl = isOnbaording
      ? applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/${currentBankToActive.id.value}`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/external-bank/${currentBankToActive.id.value}`
          : `${BASE_URL}/v1/onboarding/trust/external-bank/${currentBankToActive.id.value}`
      : applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToActive.id.value}`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToActive.id.value}`
          : `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToActive.id.value}`;

    let bodyData = {
      is_active: !currentBankToActive.is_active.value,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const makeItActiveAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await makeItActiveAccountAPI();
        if (response.status == 200) {
          // if (applicationType == 1) {
          //   setCurrentStep(5);
          // }
          // if (applicationType == 2) {
          //   setCurrentStep(4);
          // }
          setIsConfirmActive(false);
          getDetails();
          toastMessage = {
            message: response.message,
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [currentBankToActive], // Dependencies
  );
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const togglePopup = (bank) => {
    setCurrentBankToEdit(bank);
    setIsOpen(!isOpen);
    setAccountHolderNameEdit(bank.account_name.value);
    setBankNameEdit(bank.bank_name.value);
    setSwiftCodeEdit(bank.swift_code.value);
    setAddressLine1Edit(bank.address_line1.value);
    setAddressLine2Edit(bank.address_line2.value);
    setAddressLine3Edit(bank.address_line3.value);
    setBranchIdentifierEdit(bank.branch_identifier.value.id);
    setBsbEdit(bank.account_bsb.value);
    setCountryCodeEdit(bank.country_code.value);
    setTransitNumberEdit(bank.transit_number.value);
    setinstitutionNumberEdit(bank.institution_number.value);
    routingNumberEdit.setFromAPI(bank.routing_number.value);
    setAccountNumberEdit(
      ["UK", "GB", "AE"].includes(bank.country_code.value?.toUpperCase())
        ? bank.iban.value
        : bank.account_number.value,
    );
    setToCurrencyEdit(bank.currency.value.id);
    setpreselectedcashCurrencyEdit({
      value: bank.currency.value.id,
      label: bank.currency.value.name,
    });
    setpreselectedBranchIdentifierEdit({
      value: bank.branch_identifier.value.id,
      label: BranchIdentifierData.filter(
        (item) => item.value == bank.branch_identifier.value.id,
      )[0].label,
    });
    setfileAttorneyPathEdit(bank.proof_image.value);
    setpreselectedCountryCodeEdit({
      value: bank.country_code.value,
      label: countryCodeData.filter(
        (item) => item.value == bank.country_code.value,
      )[0].label,
    });
  };
  const submitApplicationAPIUpdate = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == "onboarding" ? true : false;
    let apiUrl = isOnbaording
      ? applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/${currentBankToEdit.id.value}`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/external-bank/${currentBankToEdit.id.value}`
          : `${BASE_URL}/v1/onboarding/trust/external-bank/${currentBankToEdit.id.value}`
      : applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToEdit.id.value}`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToEdit.id.value}`
          : `${BASE_URL}/v1/onboarding/external-bank/re-submit/update/${currentBankToEdit.id.value}`;

    const cleanAccountNumber = accountNumberEdit.replace(/\s+/g, "");
    const shouldUseIban = ["UK", "GB", "AE"].includes(
      countryCodeEdit?.toUpperCase(),
    );
    let bodyData = {
      bank_name: bankNameEdit,
      account_number: shouldUseIban ? null : cleanAccountNumber,
      iban: shouldUseIban ? cleanAccountNumber : null,
      account_bsb: bsbEdit,
      account_name: accountHolderNameEdit,
      swift_code: swiftCodeEdit,
      currency_id: toCurrencyEdit,
      branch_identifier: branchIdentifierEdit,
      routing_number: routingNumberEdit.value,
      transit_number: transitNumberEdit,
      institution_number: institutionNumberEdit,
      country_code: countryCodeEdit,
      user_id: userId,
      address_line1: addressLine1Edit,
      address_line2: addressLine2Edit,
      address_line3: addressLine3Edit,
      file_id: fileAttorneyPathEdit.file_id,
      payment_method: 1,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == "onboarding" ? true : false;

    let apiUrl = isOnbaording
      ? applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/submit`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/corporate/external-bank/submit`
          : `${BASE_URL}/v1/onboarding/trust/external-bank/submit`
      : applicationType == 1
        ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/add`
        : applicationType == 2
          ? `${BASE_URL}/v1/onboarding/external-bank/re-submit/add`
          : `${BASE_URL}/v1/onboarding/external-bank/re-submit/add`;
    const cleanAccountNumber = accountNumber.replace(/\s+/g, "");
    const shouldUseIban = ["UK", "GB", "AE"].includes(
      countryCode?.toUpperCase(),
    );
    let bodyData = {
      bank_name: bankName,
      account_number: shouldUseIban ? null : cleanAccountNumber,
      iban: shouldUseIban ? cleanAccountNumber : null,
      account_bsb: bsb,
      account_name: accountHolderName,
      swift_code: swiftCode,
      currency_id: toCurrency,
      branch_identifier: branchIdentifier,
      routing_number: routingNumber.value,
      transit_number: transitNumber,
      institution_number: institutionNumber,
      country_code: countryCode,
      user_id: userId,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      file_id: fileAttorneyPath.file_id,
      payment_method: 1,
      is_active: true,
      is_default: isDefault === "yes" ? true : false,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handlesave = async () => {
    handleFinalSubmit();
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        applicationType == 1
          ? `/v1/onboarding/external-bank/verification/list`
          : applicationType == 2
            ? `/v1/onboarding/corporate/external-bank/verification/list`
            : `/v1/onboarding/trust/external-bank/verification/list`,
      );

      if (response.status == 200) {
        if (response.data) {
          setBankdata(response.data);
        } else {
          setBankdata([]);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getAllEnum();
    getAllCountryCode();
    getAllCurrency();
  }, []);
  useEffect(() => {
    if (!stepStatus?.length) return;
    const isIndividual = applicationType === 1;
    const stepIndex = isIndividual ? 3 : 2;
    const step = stepStatus[stepIndex];

    if (step?.status !== "DRAFT") {
      getDetails();
    }
  }, [applicationType, stepStatus]);
  useEffect(() => {
    if (!stepStatus?.length) return;
    const isIndividual = applicationType === 1;
    const stepIndex = isIndividual ? 3 : 2;
    const step = stepStatus[stepIndex];
    if (updateFieldStatus && step?.status !== "DRAFT") {
      getDetails();
    }
  }, [applicationType, updateFieldStatus, stepStatus]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {isInReview && (
          <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
            <img
              src="/warning-circle.svg"
              alt="Info"
              className="w-4 h-4 mr-2"
            />
            <span>
              This section is <strong>in review by our onboarding team</strong>.
              You will be notified once the verification is complete.{" "}
            </span>
          </div>
        )}
        {isApproved && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.EXTERNAL_BANKS?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.EXTERNAL_BANKS.rejected_fields.length === 1
                ? "The following field requires correction:"
                : "The following fields require correction:"}{" "}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.EXTERNAL_BANKS.rejected_fields.map((field) => (
                <span
                  key={field}
                  className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                >
                  {fieldLabelMap[field] || field.replace(/_/g, " ")}
                </span>
              ))}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/cards.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">External Account</h1>
            </div>

            <ul className="space-y-2 pl-6 pr-2 text-xs font-medium text-black list-disc">
              <li>
                If your external account information has changed, you will need
                to delete your current external account from your Platform Cash
                Account and enter your new External Account.
              </li>
              <li>
                We only accept external accounts under your personal or
                corporate name.
              </li>
              <li>
                All withdrawal requests from your Caprock Merchant Managed
                Account Platform to your external account are only available to
                users who entered and verified their external account
                information during this stage. You can add more than one
                external account in several currencies by clicking "Add Account"
                after saving the account information.
              </li>
              <li className="text-[#FF5050]">
                If you need to adjust any information from the previous section,
                please click on the “Reset Application” button.
              </li>
            </ul>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="">
                <label
                  htmlFor="accountHolderName"
                  className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Account Holder Name<span className="text-red-500">*</span>
                </label>
                <input
                  id="accountHolderName"
                  name="accountHolderName"
                  type="text"
                  value={accountHolderName}
                  placeholder="Enter Name"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setAccountHolderName(e.target.value)}
                />
              </div>
              <div className="mt-4">
                <label
                  htmlFor="accountHolderName"
                  className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Bank Name<span className="text-red-500">*</span>
                </label>
                <input
                  id="bankName"
                  name="bankName"
                  type="text"
                  value={bankName}
                  placeholder="Enter Name"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setBankName(e.target.value)}
                />
              </div>
              <div className="mt-4">
                <label
                  htmlFor="accountHolderName"
                  className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Swift Code
                </label>
                <input
                  id="swiftCode"
                  name="swiftCode"
                  type="text"
                  value={swiftCode}
                  onChange={handleSwiftChange}
                  className={`${
                    swiftError && branchIdentifier != 1
                      ? "border-red-300 "
                      : "border-gray-300 "
                  }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                  placeholder="000000"
                />
                {swiftError && branchIdentifier != 1 && (
                  <p className="text-red-500 text-xs mt-1">{swiftError}</p>
                )}
              </div>
              <div>
                <label
                  htmlFor="finInstituition"
                  className="mb-1 mt-4 text-sm text-labelColour"
                >
                  Address Line 1
                </label>{" "}
                <input
                  id="finInstituition"
                  type="text"
                  value={addressLine1}
                  onChange={(e) => setAddressLine1(e.target.value)}
                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                  placeholder="Street address"
                />
              </div>
              <div>
                <label
                  htmlFor="finInstituition"
                  className="mb-1 mt-4 text-sm text-labelColour"
                >
                  Address Line 2
                </label>{" "}
                <input
                  id="finInstituition"
                  type="text"
                  value={addressLine2}
                  onChange={(e) => setAddressLine2(e.target.value)}
                  className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                  placeholder="Apartment, unit etc."
                />
              </div>
              <div>
                <label
                  htmlFor="finInstituition"
                  className="mb-1 mt-4 text-sm text-labelColour"
                >
                  Address Line 3
                </label>{" "}
                <input
                  id="finInstituition"
                  type="text"
                  value={addressLine3}
                  onChange={(e) => setAddressLine3(e.target.value)}
                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                  placeholder="City, Country etc."
                />
              </div>
            </div>
            <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="">
                <Dropdown
                  label={
                    <>
                      Branch Identifier
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={BranchIdentifierData}
                  preselectedValue={preselectedBranchIdentifier}
                  onSelect={handleSelectBranchIdentifier}
                />
              </div>
              {branchIdentifier == 1 && (
                <>
                  <div className="mt-4">
                    <label
                      htmlFor="bsb"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      BSB<span className="text-red-500">*</span>
                    </label>
                    <input
                      id="bsb"
                      name="Bsb"
                      type="text"
                      value={bsb}
                      maxLength={6}
                      onChange={(e) => handleBsbChange(e.target.value)}
                      className={`${
                        bsbError ? "border-red-300 " : "border-gray-300 "
                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                      placeholder="000000"
                    />
                    {bsbError && (
                      <p className="text-red-600 text-xs mt-1">{bsbError}</p>
                    )}
                  </div>
                </>
              )}
              {branchIdentifier == 2 && (
                <>
                  <div className="mt-4">
                    <Dropdown
                      label={
                        <>
                          Applicant's Country
                          <span className="text-red-500"> *</span>
                        </>
                      }
                      options={countryCodeData}
                      search={true}
                      preselectedValue={preselectedCountryCode}
                      onSelect={handleSelectCountryCode}
                      colorLabel=""
                    />
                  </div>
                  {countryCode == "CA" && (
                    <>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Transit Number
                        </label>{" "}
                        <input
                          id="finInstituition"
                          type="text"
                          value={transitNumber}
                          maxLength={5}
                          onChange={(e) => handleTransitChange(e.target.value)}
                          className={`${
                            transitError
                              ? "border-red-300 "
                              : "border-gray-300 "
                          }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                          placeholder="00000"
                        />
                        {transitError && (
                          <p className="text-red-600 text-xs mt-1">
                            {transitError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Institution Number
                        </label>{" "}
                        <input
                          id="finInstituition"
                          type="text"
                          value={institutionNumber}
                          onChange={(e) => setinstitutionNumber(e.target.value)}
                          className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="000000"
                        />
                      </div>
                    </>
                  )}
                </>
              )}
              {branchIdentifier == 3 && (
                <>
                  <div className="mt-4">
                    <label
                      htmlFor="finIdentifier"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Routing Number
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="finIdentifier"
                      name="finIdentifier"
                      type="text"
                      value={routingNumber.value}
                      maxLength={9}
                      onChange={(e) =>
                        routingNumber.handleChange(e.target.value)
                      }
                      className={`${
                        routingNumber.error
                          ? "border-red-300 "
                          : "border-gray-300 "
                      }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                      placeholder="000000000"
                    />
                    {routingNumber.error && (
                      <p className="text-red-600 text-sm mt-1">
                        {routingNumber.error}
                      </p>
                    )}
                  </div>
                  {/* <div className="mt-4">
                    <Dropdown
                      label={
                        <>
                          Select Payment Method
                          <span className="text-red-500"> *</span>
                        </>
                      }
                      options={paymentMethodData}
                      search={true}
                      preselectedValue={preselectedPaymentMethod}
                      onSelect={handleSelectPaymentMethod}
                      colorLabel=""
                    />
                  </div>
                  {paymentMethod == 1 && (
                    <div className="mt-4">
                      <label
                        htmlFor="finIdentifier"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        ACH Code
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="finIdentifier"
                        name="finIdentifier"
                        type="text"
                        value={achCode}
                        placeholder="23456789"
                        className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setAchCode(e.target.value)}
                      />
                    </div>
                  )} */}
                </>
              )}
              <div className="mt-4">
                <label
                  htmlFor="bsb"
                  className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Account Number or IBAN<span className="text-red-500">*</span>
                </label>
                <input
                  id="bsb"
                  name="Bsb"
                  type="text"
                  value={accountNumber}
                  placeholder="23456789"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              </div>
            </div>
            <div className="flex flex-col pr-4 pt-4">
              <div className="">
                <Dropdown
                  label={
                    <>
                      Currency
                      <span className="text-red-500">*</span>
                    </>
                  }
                  options={currencyData}
                  search={true}
                  preselectedValue={preselectedcashCurrency}
                  onSelect={handleSelectToCurrency}
                  colorLabel=""
                />
              </div>
              <div className="mt-4 flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                <label
                  htmlFor="investmentType"
                  className="text-sm text-labelColour flex items-center"
                >
                  Is Default Account?
                  <span className="text-red-500">*</span>
                </label>

                {/* Radio Buttons */}
                <div className="flex items-center gap-4">
                  <label className="flex items-center text-sm text-black">
                    <input
                      type="radio"
                      name="isDefault"
                      value="yes"
                      checked={isDefault === "yes"}
                      onChange={handleSetDefault}
                      className="confirm-check w-4 h-4 text-[#005A9C] border-gray-300 focus:ring-[#005A9C]"
                    />
                    <span className="ml-2">Yes</span>
                  </label>

                  <label className="flex items-center text-sm text-black">
                    <input
                      type="radio"
                      name="isDefault"
                      value="no"
                      checked={isDefault === "no"}
                      onChange={handleSetDefault}
                      className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005A9C]"
                    />
                    <span className="ml-2">No</span>
                  </label>
                </div>
              </div>
              <div className="flex items-center justify-between mt-4 ">
                <label
                  htmlFor="investmentType"
                  className="text-sm text-labelColour  whitespace-normal break-words block"
                >
                  Upload a copy of your External Account Verification document -
                  showing the following details (name, account number, Swift
                  Code, and bank address).
                  <span className="text-red-500">*</span>
                </label>
              </div>
              {/* Drag & Drop Upload Area */}
              <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                <input
                  type="file"
                  id="fileUpload"
                  accept=".pdf,.png,.jpeg"
                  onChange={handleFileChangeBank}
                  className="hidden"
                />
                <img
                  src="/folder-add.svg"
                  alt="Success Icon"
                  className="h-4 w-4"
                />{" "}
                <p className="mt-2 text-gray-500 text-sm">
                  Drag & Drop <br />
                  or <span className="underline">Click to Upload</span>
                </p>
              </label>
              <div className="mt-1">
                <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                  PNG
                </span>
                <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                  JPEG
                </span>
                <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                  PDF
                </span>
                <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                  &#60; 10 MB
                </span>
              </div>

              {((fileBank && fileAvailable) || fileAttorneyPath) && (
                <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(e, fileAttorneyPath);
                    }}
                    className="flex-col flex "
                  >
                    <span className="text-black break-all cursor-pointer underline">
                      {fileAttorneyPath.file_name}
                    </span>
                    <span className="text-[#46DA55] text-xs">
                      Upload Completed
                    </span>
                  </div>
                  <button
                    onClick={handleDeleteFile}
                    className="text-red-500 flex-shrink-0 font-semibold"
                  >
                    <img
                      src="/trash.svg"
                      alt="Delete Icon"
                      className="h-4 w-4 flex-shrink-0"
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-end w-full mt-4">
            <button
              onClick={(e) => {
                e.preventDefault();
                if (!accountHolderName) {
                  showToast("Please enter account holder name", "error");
                  return;
                }
                if (!bankName) {
                  showToast("Please enter bank name", "error");
                  return;
                }
                if (!toCurrency) {
                  showToast("Please select currency", "error");
                  return;
                }
                if (!branchIdentifier) {
                  showToast("Please select branch identifier", "error");
                  return;
                }
                if (branchIdentifier == 1 && (!bsb || bsbError)) {
                  showToast("Please enter a valid BSB", "error");
                  return;
                }
                if (branchIdentifier != 1 && (!swiftCode || swiftError)) {
                  showToast(
                    "Please enter a valid swift code/BIC code",
                    "error",
                  );
                  return;
                }
                if (branchIdentifier == 2 && !countryCode) {
                  showToast("Please select country", "error");
                  return;
                }
                if (
                  branchIdentifier == 2 &&
                  countryCode == "CA" &&
                  !institutionNumber
                ) {
                  showToast(
                    "Please enter financial institution identifier",
                    "error",
                  );
                  return;
                }
                if (
                  branchIdentifier == 2 &&
                  countryCode == "CA" &&
                  (!transitNumber || transitError)
                ) {
                  showToast("Please enter transit number", "error");
                  return;
                }
                if (
                  branchIdentifier == 3 &&
                  (!routingNumber.value || routingNumber.error)
                ) {
                  showToast("Please enter a valid routing number", "error");
                  return;
                }

                if (!accountNumber) {
                  showToast("Please enter account number or IBAN", "error");
                  return;
                }
                if (!fileAttorneyPath) {
                  showToast(
                    "Please upload account verification document",
                    "error",
                  );
                  return;
                }
                if (!addressLine1 && !addressLine2 && !addressLine3) {
                  showToast(
                    "Please upload account verification document",
                    "error",
                  );
                  return;
                }
                setLoading(true);
                addAccount(e);
              }}
              className="w-full md:w-auto bg-black text-white font-medium py-2 px-4 rounded-full text-sm"
            >
              Add Account
            </button>
          </div>
        </div>
        {showSavedAccount && (
          <div className="w-full p-4 mt-4 bg-white rounded-lg shadow-lg">
            {/* Header Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <img
                  src="/archive-tick.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Saved External Accounts
                </span>
              </div>
            </div>

            {/* Profile Section */}
            {bankdata.map((bank, index) => (
              <div className="relative flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 mb-6">
                {/* Toggle Button on Top Right */}
                <div className="absolute top-2 pb-4 right-4 flex items-center space-x-2">
                  {!bank.is_default.value && (
                    <button
                      onClick={() => handleDefault(bank)}
                      className="font-semibold border-2 border-[#005A9C] text-[#005A9C] text-[12px] px-3 py-1 rounded-full bg-[#005A9C] bg-opacity-20"
                    >
                      MAKE DEFAULT
                    </button>
                  )}
                  {bank.is_default.value && (
                    <button className="font-semibold border-2 border-[#34C046] text-[#34C046] text-[12px] px-3 py-1 rounded-full bg-[#34C046] bg-opacity-20">
                      DEFAULT
                    </button>
                  )}

                  {/* Active Toggle */}
                  <div className="flex items-center space-x-1 text-xs">
                    <span className="text-xs font-medium">
                      {bank.is_active.value ? "Active" : "InActive"}
                    </span>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={bank.is_active.value}
                        onChange={() => handleActive(bank)}
                      />
                      <div className="w-10 h-5 bg-gray-300 peer-checked:bg-[#75E380] rounded-full relative transition-colors duration-300">
                        <div
                          className={`absolute top-[2px] ${
                            bank.is_active.value
                              ? "translate-x-[22px]"
                              : "left-[2px]"
                          } bg-white w-4 h-4 rounded-full transition-transform duration-300`}
                        ></div>
                      </div>
                    </label>
                  </div>

                  {/* Delete Button */}
                  <button
                    onClick={() => handleDelete(bank)}
                    className="text-[#FF5050] hover:text-red-600"
                  >
                    <img src="/bag.svg" alt="Delete" className="w-4 h-4" />
                  </button>
                  <button>
                    <img
                      onClick={() => togglePopup(bank)}
                      src="/edit-details.svg"
                      alt="Edit Icon"
                      className=" top-2 right-2 cursor-pointer w-4 h-4"
                    />
                  </button>
                </div>

                <div className="grid border-b grid-cols-1 mt-4 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full pt-6 pr-6">
                  {/* Column 1 */}
                  <div className="flex flex-col md:px-4 md:pt-6">
                    <div className="flex mt-2 items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className=" text-xs text-labelColour flex items-center whitespace-normal words-break"
                      >
                        {index + 1}. {fieldLabelMap.account_name}
                      </label>
                      {bank.account_name.comments.length > 0 && (
                        <StatusButton
                          status={bank.account_name.status}
                          count={bank.account_name.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              bank.account_name,
                              `${index + 1}. Account Holder Name`,
                              bank.account_name.value,
                              "",
                            )
                          }
                        />
                      )}
                    </div>
                    <span
                      className={`${
                        bank.account_name.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      }
                      text-sm`}
                    >
                      {bank.account_name.value}
                    </span>
                    {!["UK", "GB", "AE"].includes(
                      bank.country_code.value?.toUpperCase(),
                    ) && (
                      <div className="mt-2">
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                          >
                            {fieldLabelMap.account_number}
                          </label>
                          {bank.account_number.comments.length > 0 && (
                            <StatusButton
                              status={bank.account_number.status}
                              count={bank.account_number.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  bank.account_number,
                                  "Account Number",
                                  bank.account_number.value,
                                  "",
                                )
                              }
                            />
                          )}
                        </div>
                        <div
                          className={`${
                            bank.account_number.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          }
                      text-sm`}
                        >
                          {bank.account_number.value}
                        </div>
                      </div>
                    )}
                    {["UK", "GB", "AE"].includes(
                      bank.country_code.value?.toUpperCase(),
                    ) && (
                      <div className="mt-2">
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                          >
                            {fieldLabelMap.iban}
                          </label>
                          {bank.iban.comments.length > 0 && (
                            <StatusButton
                              status={bank.iban.status}
                              count={bank.iban.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  bank.iban,
                                  " IBAN",
                                  bank.iban.value,
                                  "",
                                )
                              }
                            />
                          )}
                        </div>
                        <div
                          className={`${
                            bank.iban.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          }
                      text-sm`}
                        >
                          {bank.iban.value}
                        </div>
                      </div>
                    )}
                    <div className="flex mt-2 items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                      >
                        {fieldLabelMap.swift_code}
                      </label>
                      {bank.swift_code.comments.length > 0 && (
                        <StatusButton
                          status={bank.swift_code.status}
                          count={bank.swift_code.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              bank.swift_code,
                              "Swift Code",
                              bank.swift_code.value,
                              "",
                            )
                          }
                        />
                      )}
                    </div>
                    <div
                      className={`${
                        bank.swift_code.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      }
                      text-sm`}
                    >
                      {bank.swift_code.value}
                    </div>
                    <div className="flex flex-row gap-2 mt-2 mb-2">
                      {bank.status.value != "onboarding" && (
                        <>
                          <button className="bg-white border-[#75E380] border-2 text-[#75E380] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                            <img
                              src="/valid.svg"
                              alt="Camera Icon"
                              className="w-4 h-4"
                            />
                            Verified
                          </button>
                        </>
                      )}
                      {bank.status.value == "onboarding" && (
                        <>
                          <button className="bg-white border-[#FF5050] border-2 text-[#FF5050] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                            <img
                              src="/danger.svg"
                              alt="Camera Icon"
                              className="w-4 h-4"
                            />
                            Unverified
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Column 2 */}
                  <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                      >
                        {fieldLabelMap.branch_identifier}
                      </label>
                      {bank.branch_identifier.comments.length > 0 && (
                        <StatusButton
                          status={bank.branch_identifier.status}
                          count={bank.branch_identifier.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              bank.branch_identifier,
                              "Branch Identifier",
                              bank.branch_identifier.value,
                              "",
                            )
                          }
                        />
                      )}
                    </div>
                    <span
                      className={`${
                        bank.branch_identifier.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      }
                      text-sm`}
                    >
                      {bank.branch_identifier.value.name}
                    </span>
                    {bank.branch_identifier.value.id == 1 && (
                      <>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                          >
                            {fieldLabelMap.account_bsb}
                          </label>
                          {bank.account_bsb.comments.length > 0 && (
                            <StatusButton
                              status={bank.account_bsb.status}
                              count={bank.account_bsb.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  bank.account_bsb,
                                  "BSB",
                                  bank.account_bsb.value,
                                  "",
                                )
                              }
                            />
                          )}
                        </div>
                        <span
                          className={`${
                            bank.account_bsb.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          }
                      text-sm`}
                        >
                          {bank.account_bsb.value}
                        </span>
                      </>
                    )}
                    {bank.branch_identifier.value.id == 2 && (
                      <>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            {fieldLabelMap.country_code}
                          </label>
                          {bank.country_code.comments.length > 0 && (
                            <StatusButton
                              status={bank.country_code.status}
                              count={bank.country_code.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  bank.country_code,
                                  "Country",
                                  bank.country_code.value,
                                  "",
                                )
                              }
                            />
                          )}
                        </div>
                        <span
                          className={`${
                            bank.country_code.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          }
                      text-sm`}
                        >
                          {bank.country_code.value}
                        </span>
                        {bank.country_code.value == "CA" && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                              >
                                {fieldLabelMap.institution_number}
                              </label>
                              {bank.institution_number.comments.length > 0 && (
                                <StatusButton
                                  status={bank.institution_number.status}
                                  count={
                                    bank.institution_number.comments?.length
                                  }
                                  openSection={() =>
                                    handleStatusClick(
                                      bank.institution_number,
                                      "Financial Institution Identifier",
                                      bank.institution_number.value,
                                      "",
                                    )
                                  }
                                />
                              )}
                            </div>
                            <span
                              className={`${
                                bank.institution_number.status == "rejected"
                                  ? "border-[#FF5050] border-2"
                                  : ""
                              }
                      text-sm`}
                            >
                              {bank.institution_number.value}
                            </span>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                              >
                                {fieldLabelMap.transit_number}
                              </label>
                              {bank.transit_number.comments.length > 0 && (
                                <StatusButton
                                  status={bank.transit_number.status}
                                  count={bank.transit_number.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      bank.transit_number,
                                      "Transit Number",
                                      bank.transit_number.value,
                                      "",
                                    )
                                  }
                                />
                              )}
                            </div>
                            <span
                              className={`${
                                bank.transit_number.status == "rejected"
                                  ? "border-[#FF5050] border-2"
                                  : ""
                              }
                      text-sm`}
                            >
                              {bank.transit_number.value}
                            </span>
                          </>
                        )}
                      </>
                    )}
                    {bank.branch_identifier.value.id == 3 && (
                      <>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                          >
                            {fieldLabelMap.routing_number}
                          </label>
                          {bank.routing_number.comments.length > 0 && (
                            <StatusButton
                              status={bank.routing_number.status}
                              count={bank.routing_number.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  bank.routing_number,
                                  "Routing Number",
                                  bank.routing_number.value,
                                  "",
                                )
                              }
                            />
                          )}
                        </div>
                        <span
                          className={`${
                            bank.routing_number.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : ""
                          }
                      text-sm`}
                        >
                          {bank.routing_number.value}
                        </span>
                      </>
                    )}
                  </div>

                  {/* Column 3 */}
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <div className="flex mt-2 items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                      >
                        {fieldLabelMap.currency}
                      </label>
                      {bank.currency.comments.length > 0 && (
                        <StatusButton
                          status={bank.currency.status}
                          count={bank.currency.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              bank.currency,
                              "Currency",
                              bank.currency.value,
                              "",
                            )
                          }
                        />
                      )}
                    </div>
                    <div
                      className={`${
                        bank.currency.status == "rejected"
                          ? "border-[#FF5050] border-2"
                          : ""
                      }
                      text-sm`}
                    >
                      {bank.currency.value.name}
                    </div>
                    <div className="mb-2 mt-4">
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                        >
                          Uploaded Docs
                        </label>
                        {bank.proof_image.comments.length > 0 && (
                          <StatusButton
                            status={bank.proof_image.status}
                            count={bank.proof_image.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                bank.proof_image,
                                "Account Number or IBAN",
                                bank.proof_image.value,
                                "",
                              )
                            }
                          />
                        )}
                      </div>
                      {bank.proof_image.value && (
                        <div
                          className={`${
                            bank.proof_image.status == "rejected"
                              ? "border-[#FF5050] border-2"
                              : "border"
                          }  mt-4 bg-white shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                        >
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(e, bank.proof_image.value);
                            }}
                            className="flex-col flex "
                          >
                            <span className="text-black break-all cursor-pointer underline">
                              {bank.proof_image.value.file_name}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <div className="">
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-xs text-labelColour flex items-center whitespace-normal words-break"
                        >
                          {fieldLabelMap.address_line1}
                        </label>
                        {bank.address_line1.comments.length > 0 && (
                          <StatusButton
                            status={bank.address_line1.status}
                            count={bank.address_line1.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                bank.address_line1,
                                "Address",
                                bank.address_line1.value,
                                "",
                              )
                            }
                          />
                        )}
                      </div>
                      <div
                        className={`${
                          bank.address_line1.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        {bank.address_line1.value != null
                          ? bank.address_line1.value
                          : ""}
                      </div>
                      <div
                        className={`${
                          bank.address_line2.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        {bank.address_line2.value != null
                          ? bank.address_line2.value
                          : ""}
                      </div>
                      <div
                        className={`${
                          bank.address_line3.status == "rejected"
                            ? "border-[#FF5050] border-2"
                            : "border"
                        }  mt-4 bg-white shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                      >
                        {bank.address_line3.value != null
                          ? bank.address_line3.value
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {isOpen && currentBankToEdit && (
              <div className="fixed inset-0   flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white h-[90vh] rounded-lg w-[90%] max-w-[900px] p-6  overflow-y-auto">
                  {/* Modal Header */}
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-medium text-center w-full">
                      Edit External Account
                    </h2>
                    <button
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      <img
                        src="/add.svg"
                        alt="Close"
                        className="w-8 h-8 md:w-10 md:h-10"
                      />
                    </button>
                  </div>

                  {/* Modal Content */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                      <div className="">
                        <label
                          htmlFor="accountHolderName"
                          className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                        >
                          Account Holder Name
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          id="accountHolderName"
                          name="accountHolderName"
                          type="text"
                          value={accountHolderNameEdit}
                          placeholder="Enter Name"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) =>
                            setAccountHolderNameEdit(e.target.value)
                          }
                        />
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="accountHolderName"
                          className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                        >
                          Bank Name<span className="text-red-500">*</span>
                        </label>
                        <input
                          id="bankName"
                          name="bankName"
                          type="text"
                          value={bankNameEdit}
                          placeholder="Enter Name"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) => setBankNameEdit(e.target.value)}
                        />
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="accountHolderName"
                          className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                        >
                          Swift Code
                        </label>
                        <input
                          id="swiftCode"
                          name="swiftCode"
                          type="text"
                          value={swiftCodeEdit}
                          onChange={handleSwiftChangeEdit}
                          className={`${
                            swiftError && branchIdentifierEdit != 1
                              ? "border-red-300 "
                              : "border-gray-300 "
                          }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                          placeholder="000000"
                        />
                        {swiftError && branchIdentifierEdit != 1 && (
                          <p className="text-red-500 text-xs mt-1">
                            {swiftError}
                          </p>
                        )}
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Address Line 1
                        </label>{" "}
                        <input
                          id="finInstituition"
                          type="text"
                          value={addressLine1Edit}
                          onChange={(e) => setAddressLine1Edit(e.target.value)}
                          className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="Street address"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Address Line 2
                        </label>{" "}
                        <input
                          id="finInstituition"
                          type="text"
                          value={addressLine2Edit}
                          onChange={(e) => setAddressLine2Edit(e.target.value)}
                          className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="Apartment, unit etc."
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="finInstituition"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Address Line 3
                        </label>{" "}
                        <input
                          id="finInstituition"
                          type="text"
                          value={addressLine3Edit}
                          onChange={(e) => setAddressLine3Edit(e.target.value)}
                          className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                          placeholder="City, Country etc."
                        />
                      </div>
                    </div>
                    <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                      <div className="">
                        <Dropdown
                          label={
                            <>
                              Branch Identifier
                              <span className="text-red-500"> *</span>
                            </>
                          }
                          options={BranchIdentifierData}
                          preselectedValue={preselectedBranchIdentifierEdit}
                          onSelect={handleSelectBranchIdentifierEdit}
                        />
                      </div>
                      {branchIdentifierEdit == 1 && (
                        <>
                          <div className="mt-4">
                            <label
                              htmlFor="bsb"
                              className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                            >
                              BSB<span className="text-red-500">*</span>
                            </label>
                            <input
                              id="bsb"
                              name="Bsb"
                              type="text"
                              value={bsbEdit}
                              maxLength={6}
                              onChange={(e) =>
                                handleBsbChangeEdit(e.target.value)
                              }
                              className={`${
                                bsbError
                                  ? "border-red-300 "
                                  : "border-gray-300 "
                              }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                              placeholder="000000"
                            />
                            {bsbError && (
                              <p className="text-red-600 text-xs mt-1">
                                {bsbError}
                              </p>
                            )}
                          </div>
                        </>
                      )}
                      {branchIdentifierEdit == 2 && (
                        <>
                          <div className="mt-4">
                            <Dropdown
                              label={
                                <>
                                  Applicant's Country
                                  <span className="text-red-500"> *</span>
                                </>
                              }
                              options={countryCodeData}
                              search={true}
                              preselectedValue={preselectedCountryCodeEdit}
                              onSelect={handleSelectCountryCodeEdit}
                              colorLabel=""
                            />
                          </div>
                          {countryCodeEdit == "CA" && (
                            <>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 mt-4 text-sm text-labelColour"
                                >
                                  Transit Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={transitNumberEdit}
                                  maxLength={5}
                                  onChange={(e) =>
                                    handleTransitChange(e.target.value)
                                  }
                                  className={`${
                                    transitError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="00000"
                                />
                                {transitError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {transitError}
                                  </p>
                                )}
                              </div>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 mt-4 text-sm text-labelColour"
                                >
                                  Institution Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={institutionNumberEdit}
                                  maxLength={5}
                                  onChange={(e) =>
                                    handleTransitChangeEdit(e.target.value)
                                  }
                                  className={`${
                                    transitError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="00000"
                                />
                                {transitError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {transitError}
                                  </p>
                                )}
                              </div>
                            </>
                          )}
                        </>
                      )}
                      {branchIdentifierEdit == 3 && (
                        <>
                          <div className="mt-4">
                            <label
                              htmlFor="finIdentifier"
                              className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                            >
                              Routing Number
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              id="finIdentifier"
                              name="finIdentifier"
                              type="text"
                              value={routingNumberEdit.value}
                              maxLength={9}
                              onChange={(e) =>
                                routingNumberEdit.handleChange(e.target.value)
                              }
                              className={`${
                                routingNumberEdit.error
                                  ? "border-red-300 "
                                  : "border-gray-300 "
                              }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                              placeholder="000000000"
                            />
                            {routingNumberEdit.error && (
                              <p className="text-red-600 text-sm mt-1">
                                {routingNumberEdit.error}
                              </p>
                            )}
                          </div>
                          {/* <div className="mt-4">
                    <Dropdown
                      label={
                        <>
                          Select Payment Method
                          <span className="text-red-500"> *</span>
                        </>
                      }
                      options={paymentMethodData}
                      search={true}
                      preselectedValue={preselectedPaymentMethod}
                      onSelect={handleSelectPaymentMethod}
                      colorLabel=""
                    />
                  </div>
                  {paymentMethod == 1 && (
                    <div className="mt-4">
                      <label
                        htmlFor="finIdentifier"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        ACH Code
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="finIdentifier"
                        name="finIdentifier"
                        type="text"
                        value={achCode}
                        placeholder="23456789"
                        className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setAchCode(e.target.value)}
                      />
                    </div>
                  )} */}
                        </>
                      )}
                      <div className="mt-4">
                        <label
                          htmlFor="bsb"
                          className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                        >
                          Account Number or IBAN
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          id="bsb"
                          name="Bsb"
                          type="text"
                          value={accountNumberEdit}
                          placeholder="23456789"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) => setAccountNumberEdit(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col pr-4 pt-4">
                      <div className="">
                        <Dropdown
                          label={
                            <>
                              Currency
                              <span className="text-red-500">*</span>
                            </>
                          }
                          options={currencyData}
                          search={true}
                          preselectedValue={preselectedcashCurrencyEdit}
                          onSelect={handleSelectToCurrencyEdit}
                          colorLabel=""
                        />
                      </div>
                      <div className="flex items-center justify-between mt-4 ">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Upload a copy of your External Account Verification
                          document - showing the following details (name,
                          account number, Swift Code, and bank address).
                          <span className="text-red-500">*</span>
                        </label>
                      </div>
                      {/* Drag & Drop Upload Area */}
                      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                        <input
                          type="file"
                          id="fileUpload"
                          accept=".pdf,.png,.jpeg"
                          onChange={handleFileChangeBankEdit}
                          className="hidden"
                        />
                        <img
                          src="/folder-add.svg"
                          alt="Success Icon"
                          className="h-4 w-4"
                        />{" "}
                        <p className="mt-2 text-gray-500 text-sm">
                          Drag & Drop <br />
                          or <span className="underline">Click to Upload</span>
                        </p>
                      </label>
                      <div className="mt-1">
                        <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PNG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          JPEG
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          PDF
                        </span>
                        <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                          &#60; 10 MB
                        </span>
                      </div>

                      {((fileBankEdit && fileAvailableEdit) ||
                        fileAttorneyPathEdit) && (
                        <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(e, fileAttorneyPathEdit);
                            }}
                            className="flex-col flex "
                          >
                            <span className="text-black break-all cursor-pointer underline">
                              {fileAttorneyPathEdit.file_name}
                            </span>
                            <span className="text-[#46DA55] text-xs">
                              Upload Completed
                            </span>
                          </div>
                          <button
                            onClick={handleDeleteFileEdit}
                            className="text-red-500 flex-shrink-0 font-semibold"
                          >
                            <img
                              src="/trash.svg"
                              alt="Delete Icon"
                              className="h-4 w-4 flex-shrink-0"
                            />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Modal Footer */}
                  <div className="flex flex-col md:flex-row justify-center md:space-x-4 space-y-2 md:space-y-0 mt-6">
                    <button
                      onClick={() => {
                        setIsOpen(false);
                      }}
                      className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (!accountHolderNameEdit) {
                          showToast(
                            "Please enter account holder name",
                            "error",
                          );
                          return;
                        }
                        if (!bankNameEdit) {
                          showToast("Please enter bank name", "error");
                          return;
                        }
                        if (!toCurrencyEdit) {
                          showToast("Please select currency", "error");
                          return;
                        }
                        if (!branchIdentifierEdit) {
                          showToast("Please select branch identifier", "error");
                          return;
                        }
                        if (
                          branchIdentifierEdit == 1 &&
                          (!bsbEdit || bsbError)
                        ) {
                          showToast("Please enter BSB", "error");
                          return;
                        }
                        if (
                          branchIdentifierEdit != 1 &&
                          (!swiftCodeEdit || swiftError)
                        ) {
                          showToast(
                            "Please enter a valid swift code/BIC code",
                            "error",
                          );
                          return;
                        }
                        if (branchIdentifierEdit == 2 && !countryCodeEdit) {
                          showToast("Please select country", "error");
                          return;
                        }
                        if (
                          branchIdentifierEdit == 2 &&
                          countryCodeEdit == "CA" &&
                          !institutionNumberEdit
                        ) {
                          showToast(
                            "Please enter financial institution identifier",
                            "error",
                          );
                          return;
                        }
                        if (
                          branchIdentifierEdit == 2 &&
                          countryCodeEdit == "CA" &&
                          (!transitNumberEdit || transitError)
                        ) {
                          showToast("Please enter transit number", "error");
                          return;
                        }
                        if (
                          branchIdentifierEdit == 3 &&
                          (!routingNumberEdit.value || routingNumberEdit.error)
                        ) {
                          showToast("Please enter routing number", "error");
                          return;
                        }

                        if (!accountNumberEdit) {
                          showToast(
                            "Please enter account number or IBAN",
                            "error",
                          );
                          return;
                        }
                        if (!fileAttorneyPathEdit) {
                          showToast(
                            "Please upload account verification document",
                            "error",
                          );
                          return;
                        }
                        if (
                          !addressLine1Edit &&
                          !addressLine2Edit &&
                          !addressLine3Edit
                        ) {
                          showToast(
                            "Please upload account verification document",
                            "error",
                          );
                          return;
                        }
                        setLoading(true);
                        updateAccount(e);
                      }}
                      className={`px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800`}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={currentDocument.presigned_url}
                fileName={currentDocument.file_name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
            {isConfirmDelete && currentBank && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                  <button class="absolute top-3 right-3 text-black text-xl font-bold">
                    &times;
                  </button>

                  <div class="flex justify-center items-center mb-4">
                    <div class="flex items-center justify-center">
                      <img
                        src="/delete-warning.svg"
                        alt="Add Template Icon"
                        className="h-10 w-10"
                      />
                    </div>
                  </div>
                  <>
                    <h2 class="text-lg font-medium mb-2">Are you sure?</h2>
                    <p class="text-sm text-black mb-4">
                      Do you want to delete this external account details?
                    </p>

                    <div class="flex justify-center space-x-4">
                      <button
                        onClick={() => {
                          setIsConfirmDelete(false);
                        }}
                        class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                      >
                        No
                      </button>
                      <button
                        onClick={(e) => {
                          setLoading(true);
                          deleteAccount(e);
                        }}
                        class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                      >
                        Yes
                      </button>
                    </div>
                  </>
                  {/* {currentBank.is_default.value && (
                    <>
                      <h2 class="text-lg font-medium mb-2">
                        Are you sure you want to delete the default external
                        account?
                      </h2>
                      <p class="text-sm text-black mb-4">
                        To delete the current default external account, please
                        choose your new default external account from the list
                        below.
                      </p>
                      <div className="m-4">
                        <Dropdown
                          label="Choose Default External Account"
                          options={accountList}
                          search={true}
                          preselectedValue={preselectedDefaultAccount}
                          onSelect={handleSelectDefaultAccount}
                          colorLabel=""
                        />
                      </div>
                      <div class="flex justify-center space-x-4">
                        <button
                          onClick={() => {
                            setIsConfirmDelete(false);
                          }}
                          class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            setLoading(true);
                            deleteAccount(e);
                          }}
                          class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                        >
                          Confirm
                        </button>
                      </div>
                    </>
                  )} */}
                </div>
              </div>
            )}
            {isConfirmDefault && currentBankToDefault && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                  <button class="absolute top-3 right-3 text-black text-xl font-bold">
                    &times;
                  </button>

                  <div class="flex justify-center items-center mb-4">
                    <div class="flex items-center justify-center">
                      <img
                        src="/warning-circle.svg"
                        alt="Add Template Icon"
                        className="h-10 w-10"
                      />
                    </div>
                  </div>

                  <h2 class="text-lg font-medium mb-2">Are you sure?</h2>
                  <p class="text-sm text-black mb-4">
                    Do you want to make this external account default?
                  </p>

                  <div class="flex justify-center space-x-4">
                    <button
                      onClick={() => {
                        setIsConfirmDefault(false);
                      }}
                      class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                    >
                      No
                    </button>
                    <button
                      onClick={(e) => {
                        setLoading(true);
                        makeItDefaultAccount(e);
                      }}
                      class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            )}
            {isConfirmActive && currentBankToActive && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                  <button class="absolute top-3 right-3 text-black text-xl font-bold">
                    &times;
                  </button>

                  <div class="flex justify-center items-center mb-4">
                    <div class="flex items-center justify-center">
                      <img
                        src="/warning-circle.svg"
                        alt="Add Template Icon"
                        className="h-10 w-10"
                      />
                    </div>
                  </div>
                  <h2 class="text-lg font-medium mb-2">Are you sure?</h2>
                  <p class="text-sm text-black mb-4">
                    Do you want to change this external account status?
                  </p>
                  <div class="flex justify-center space-x-4">
                    <button
                      onClick={() => {
                        setIsConfirmActive(false);
                      }}
                      class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                    >
                      No
                    </button>
                    <button
                      onClick={(e) => {
                        setLoading(true);
                        makeItActiveAccount(e);
                      }}
                      class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                    >
                      Yes
                    </button>
                  </div>
                  {/* {(!currentBankToActive.is_default.value ||
                    (currentBankToActive.is_default.value &&
                      !currentBankToActive.is_active.value)) && (
                    <>
                      <h2 class="text-lg font-medium mb-2">Are you sure?</h2>
                      <p class="text-sm text-black mb-4">
                        Do you want to change this external account status?
                      </p>
                      <div class="flex justify-center space-x-4">
                        <button
                          onClick={() => {
                            setIsConfirmActive(false);
                          }}
                          class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                        >
                          No
                        </button>
                        <button
                          onClick={(e) => {
                            setLoading(true);
                            makeItActiveAccount(e);
                          }}
                          class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                        >
                          Yes
                        </button>
                      </div>
                    </>
                  )} */}
                  {/* {currentBankToActive.is_default.value &&
                    currentBankToActive.is_active.value && (
                      <>
                        <h2 class="text-lg font-medium mb-2">
                          Are you sure you want to deactivate the default
                          external account?
                        </h2>
                        <p class="text-sm text-black mb-4">
                          To deactivate the current default external account,
                          please choose your new default external account from
                          the list below.
                        </p>
                        <div className="m-4">
                          <Dropdown
                            label="Choose Default External Account"
                            options={accountList}
                            search={true}
                            preselectedValue={preselectedDefaultAccount}
                            onSelect={handleSelectDefaultAccount}
                            colorLabel=""
                          />
                        </div>
                        <div class="flex justify-center space-x-4">
                          <button
                            onClick={() => {
                              setIsConfirmActive(false);
                            }}
                            class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={(e) => {
                              setLoading(true);
                              makeItActiveAccount(e);
                            }}
                            class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                          >
                            Confirm
                          </button>
                        </div>
                      </>
                    )} */}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      <footer className=" mt-4 flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        {isEditable && (
          <>
            <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
              <ConfirmResetButton
                onConfirm={handleReset}
                isReset={true}
                isBack={true}
                onBack={handleBack}
              />
            </div>
            <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
              <div className="w-full md:w-auto flex justify-center md:justify-end">
                {/* <button className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm">
              <span>Save as Draft</span>
            </button> */}
              </div>
              <ConfirmContinueButton
                onContinue={handleContinue}
                buttonText="Continue"
                confirmTitle="Save Section"
                confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
              />
            </div>
          </>
        )}
        {isLocked && (
          <>
            <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
              <ConfirmResetButton
                onConfirm={handleReset}
                isReset={false}
                isBack={true}
                onBack={handleBack}
              />
            </div>

            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
              {/* Save as Draft */}
              <button
                onClick={() => {
                  if (applicationType == 1 && individualAccountType == 5) {
                    setCurrentStep(5);
                  } else {
                    setCurrentStep(4);
                  }
                }}
                className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Next</span>
              </button>
            </div>
          </>
        )}
      </footer>
    </div>
  );
};

export default LinkAccount;
